// extracted by mini-css-extract-plugin
export default {"top":"WasmMsgPanel_top__Rknph","message":"WasmMsgPanel_message__-aD30","showDecoded":"WasmMsgPanel_showDecoded__dpz41"};